import axios from "axios";

export default {
  state: {
    token: localStorage.getItem("token") || null,
    userRole: localStorage.getItem("role") || null,
    firstName: localStorage.getItem("firstName") || null,
    lastName: localStorage.getItem("lastName") || null,
    email: localStorage.getItem("email") || null,
    userMustChangePassword:
      JSON.parse(localStorage.getItem("userMustChangePassword")) || null,
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
  },
  mutations: {
    login(state, token) {
      state.token = token;
    },
    logout(state) {
      state.token = null;
    },
    getUserRole(state, role) {
      state.userRole = role;
    },
    getFullName(state, name) {
      state.firstName = name.firstName;
      state.lastName = name.lastName;
      state.email = name.email;
      state.userMustChangePassword = name.userMustChangePassword;
    },
    getUserId(state, userId) {
      state.userId = userId;
    },

    setUserMustChangePassword(state, userMustChangePassword) {
      state.userMustChangePassword = userMustChangePassword;
    },
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BASE_URL}/user/login`,
          {
            ...credentials,
          }
        );

        const token = res.data.token;
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("token", token);
        commit("login", token);

        const role = res.data.user.userRole;
        localStorage.setItem("role", role);
        commit("getUserRole", role);

        const firstName = res.data.user.firstName;
        const lastName = res.data.user.lastName;
        const email = res.data.user.userEmail;
        const userMustChangePassword = res.data.user.userMustChangePassword;

        localStorage.setItem("firstName", firstName);
        localStorage.setItem("lastName", lastName);
        localStorage.setItem("email", email);
        localStorage.setItem("userMustChangePassword", userMustChangePassword);
        commit("getFullName", { firstName, lastName, email });
        commit("setUserMustChangePassword", userMustChangePassword);
      } catch (e) {
        dispatch("logout");
        throw e;
      }
    },
    logout({ commit }) {
      commit("logout");
      localStorage.clear();
      delete axios.defaults.headers.common["Authorization"];
    },
  },
};
